import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { Waves } from "lucide-react";

// Set to true to show the "Under Construction" page, or false to show the actual app.
// Since this is defined entirely in index.js, you only need to commit this single file.
const UNDER_CONSTRUCTION = false;

function UnderConstruction() {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center bg-[#050914] text-white overflow-hidden font-sans">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1429] via-[#050914] to-[#050914]" />
      
      {/* Glowing background highlights */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full bg-[#00F0FF]/10 blur-[100px] pointer-events-none animate-pulse" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full bg-blue-600/10 blur-[100px] pointer-events-none animate-pulse" style={{ animationDelay: "2s" }} />

      {/* Decorative Wave at the bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none z-0 opacity-20">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[120px] text-[#00F0FF]">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V0C26.9,8.75,57.05,18.3,90.3,25.8,177.14,45.38,250.8,69.57,321.39,56.44Z" fill="currentColor"></path>
        </svg>
      </div>

      <div className="relative z-10 max-w-xl mx-auto px-6 text-center flex flex-col items-center">
        {/* Emblem logo */}
        <div className="mb-8 p-4 bg-[#0B1429]/60 border border-[#00F0FF]/20 rounded-2xl shadow-[0_0_50px_rgba(0,240,255,0.1)] backdrop-blur-xl">
          <div className="relative flex items-center justify-center w-20 h-20 rounded-xl bg-gradient-to-br from-[#00F0FF] to-blue-600">
            <Waves className="w-10 h-10 text-white animate-bounce" style={{ animationDuration: "3s" }} />
          </div>
        </div>

        {/* Heading */}
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight leading-tight mb-4">
          <span className="block text-white">ASIAN MASTERS</span>
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#00F0FF] to-blue-400">
            SWIMMING 2026
          </span>
        </h1>

        {/* Under Construction badge */}
        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full border border-[#00F0FF]/30 bg-[#0B1429]/80 backdrop-blur-md mb-6 shadow-[0_0_15px_rgba(0,240,255,0.1)]">
          <span className="w-2 h-2 rounded-full bg-[#00F0FF] animate-pulse" />
          <span className="text-xs uppercase tracking-widest text-[#00F0FF] font-bold">
            Site Under Construction
          </span>
        </div>

        {/* Text */}
        <p className="text-gray-400 text-base sm:text-lg leading-relaxed mb-8 max-w-md">
          We are diving deep to prepare the ultimate experience for the Asian Masters Swimming Championships. 
          The official portal will launch shortly.
        </p>

        {/* Footer */}
        <div className="text-xs text-gray-500 tracking-wider">
          © 2026 2nd Asian Masters Swimming Championships · Bengaluru
        </div>
      </div>
    </div>
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {UNDER_CONSTRUCTION ? (
      <UnderConstruction />
    ) : (
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    )}
  </React.StrictMode>,
);
